import { Checkbox } from "@mui/material";
import { useAdminAuth } from "context/context";
import React from "react";

const useDataTable = (record, key) => {
  const [selectedId, setSelectedId] = React.useState([]);

  //*********Handle check/uncheck all ************** */
  const checkUncheckAll = () => {
    if (selectedId.length > 0 && selectedId.length === record.length) {
      setSelectedId([]);
    } else {
      setSelectedId(record.map((data) => data[key]));
    }
  };

  // this function is used for check/uncheck single data
  const checkHandler = (id) => {
    if (selectedId.includes(id)) {
      setSelectedId(selectedId.filter((data) => data !== id));
    } else {
      setSelectedId([...selectedId, id]);
    }
  };

  const TableHead = ({ type, role, disabled = false }) => {
    const { roles } = useAdminAuth();
    return (
      <>
        {type === "acl" &&
          (roles.includes(role) ? (
            record.length > 0 && (
              <Checkbox
                onChange={checkUncheckAll}
                checked={
                  JSON.stringify(selectedId) ===
                  JSON.stringify(record.map((data) => data[key]))
                }
                className="p-0"
                disabled={disabled}
              />
            )
          ) : (
            <Checkbox
              onChange={checkUncheckAll}
              checked={
                JSON.stringify(selectedId) ===
                JSON.stringify(record.map((data) => data[key]))
              }
              className="p-0"
              disabled
            />
          ))}
        {type !== "acl" && record.length > 0 && (
          <Checkbox
            onChange={checkUncheckAll}
            checked={
              JSON.stringify(selectedId) ===
              JSON.stringify(record.map((data) => data[key]))
            }
            className="p-0"
            disabled={disabled}
          />
        )}
      </>
    );
  };

  const TableBody = ({ id, type, role, disabled = false }) => {
    const { roles } = useAdminAuth();
    return (
      <>
        {type === "acl" &&
          (roles.includes(role) ? (
            <Checkbox
              checked={selectedId.includes(id)}
              onChange={() => checkHandler(id)}
              className="p-0"
              disabled={!selectedId.includes(id) && disabled}
            />
          ) : (
            <Checkbox
              checked={selectedId.includes(id)}
              onChange={() => checkHandler(id)}
              className="p-0"
              disabled
            />
          ))}
        {type !== "acl" && (
          <Checkbox
            checked={selectedId.includes(id)}
            onChange={() => checkHandler(id)}
            className="p-0"
            disabled={!selectedId.includes(id) && disabled}
          />
        )}
      </>
    );
  };

  return {
    TableHead,
    TableBody,
    selectedId,
    setSelectedId,
  };
};

export default useDataTable;
